module.exports = __webpack_public_path__ + "static/media/et.730396ca.svg";